import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Table } from "antd";
import { AiOutlineBars } from "react-icons/ai";
import { encrypt } from "../../../../utils/crypto";
import api from "../../../../api/axios";
import { companyID } from "../../../../auth";

const PIPDashboard = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const getPipData = async () => {
    const company_id = companyID();
    try {
      const response = await api.get(`api/pip-data?company_id=${company_id}`);
      setData(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getPipData();
  }, []);

  const columns = [
    {
      title: t("Name"),
      dataIndex: "name",
      render: (text, record) => {
        // const encryptedEmployeeId = encrypt(record.id);
        return (
          <span className="table-avatar">
            {/* <Link to={`profile/${encryptedEmployeeId}`} className="avatar">
              <span>
                <img
                  alt=""
                  src={imageMap[record.id] || User}
                  style={{ borderRadius: "50%" }}
                />
              </span>
            </Link> */}
            {/* <Link to={`profile/${encryptedEmployeeId}`}> */}
            <span>
              {record?.first_name} {record?.middle_name} {record?.last_name}
            </span>
            {/* </Link> */}
          </span>
        );
      },
    },

    {
      title: t("Employment ID"),
      dataIndex: "employment_id",
    },
    {
      title: t("Start  Date"),
      dataIndex: "start_date",
    },
    {
      title: t("End Date"),
      dataIndex: "end_date",
    },

    {
      title: t("Status"),
      render: (text, record) => {
        return (
          <span
            className={`badge bg-${
              record?.action == "on_notice" ? "success" : "danger"
            }`}
          >
            {record?.action == "on_notice" ? t("On Notice") : t("ON PIP")}
          </span>
        );
      },
    },
    {
      title: t("Action"),
      render: (text, record) => {
        // const deactivate = record?.status == "1" ? false : true;
        return (
          <Link to={`../pip/${encrypt(record?.employee_id)}`}>
            <button
              className="list-group-item list-group-item-action"
              // data-bs-toggle="modal"
              // data-bs-target="#delete_employee"
              // disabled={deactivate || record.id === Number(loginEmployeeId)}
              // onClick={() => handleDelete(record.id)}
            >
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip
                    id="tooltip-view"
                    style={{ fontSize: "12px", padding: "2px" }}
                  >
                    {t("View Detail")}
                  </Tooltip>
                }
              >
                <i className={`fa-solid fa-bars text-primary`}></i>
              </OverlayTrigger>
            </button>
          </Link>

          // <div className="action-menu text-end">
          //   <div className="d-flex gap-2 mt-2">
          //     <ProtectedButton page="employees" action="edit">
          //       <button
          //         className="list-group-item list-group-item-action"
          //         disabled={deactivate}
          //         onClick={(e) => {
          //           e.preventDefault();
          //           editHandler(record.id);
          //           setIsEditModalOpen(true);
          //         }}
          //       >
          //         <OverlayTrigger
          //           placement="top"
          //           overlay={
          //             <Tooltip
          //               id="tooltip-view"
          //               style={{ fontSize: "12px", padding: "2px" }}
          //             >
          //               {t("Edit Employee")}
          //             </Tooltip>
          //           }
          //         >
          //           <i
          //             className={`fa fa-pencil m-r-5 text-${
          //               deactivate ? "secondary" : "info"
          //             }`}
          //           />
          //         </OverlayTrigger>
          //       </button>
          //     </ProtectedButton>
          //     <button
          //       className="list-group-item list-group-item-action"
          //       data-bs-toggle="modal"
          //       data-bs-target="#delete_employee"
          //       disabled={deactivate || record.id === Number(loginEmployeeId)}
          //       onClick={() => handleDelete(record.id)}
          //     >
          //       <OverlayTrigger
          //         placement="top"
          //         overlay={
          //           <Tooltip
          //             id="tooltip-view"
          //             style={{ fontSize: "12px", padding: "2px" }}
          //           >
          //             {t("Deactivate Employee")}
          //           </Tooltip>
          //         }
          //       >
          //         <i
          //           className={`fa-solid fa-power-off text-${
          //             deactivate || record.id !== Number(loginEmployeeId)
          //               ? "success"
          //               : "secondary"
          //           }`}
          //         ></i>
          //       </OverlayTrigger>
          //     </button>
          //     <button
          //       className="list-group-item list-group-item-action"
          //       disabled={
          //         deactivate ||
          //         (record.id === Number(loginEmployeeId) &&
          //           record?.resignation_status == null)
          //       }
          //       onClick={() => handleShowTermination(record)}
          //     >
          //       <OverlayTrigger
          //         placement="top"
          //         overlay={
          //           <Tooltip
          //             id="tooltip-view"
          //             style={{ fontSize: "12px", padding: "2px" }}
          //           >
          //             {t("Terminate Employee")}
          //           </Tooltip>
          //         }
          //       >
          //
        );
      },
    },
  ];
  return (
    <div>
      <div className="page-wrapper" style={{ position: "relative" }}>
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle={t("PIP Dashboard")}
            title={t("Dashboard")}
            subtitle={t("PIP Dashboard")}
            // name={t("Add Employee")}
            // openModal={openModal}
            // page="employees"
            action="create"
          />

          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <Table
                  className="table-striped"
                  columns={columns}
                  dataSource={data}
                  rowKey={(record) => record.employee_id}
                  pagination={{ pageSize: 10 }}
                  scroll={{ x: true }}
                  tableLayout="auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PIPDashboard;
